// extracted by mini-css-extract-plugin
export default {"additionalNote":"Cart_additionalNote__XRX1h"};